import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import { SERVER_URI, URL_EXTENSION } from '../utility/config'
import moment from 'moment'
import DatePicker from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker.css'
import fi from 'date-fns/locale/fi' // the locale you want

function CreatedMessage(props) {
  window.setTimeout(function () {
    // Move to a new location
    window.location.href = `${URL_EXTENSION}calendars`
  }, 1100)
  return (
    <div>
      <h2 className='message_title'>Työvuoro(t) lisätty</h2>
    </div>
  )
}

function AddShiftPopup(props) {
  const [show, setShow] = useState(false)
  const [overMidnightShift, setOverMidnightShift] = useState(false)
  const [selectedDriversList, setSelectedDriversList] = useState([])
  const [message, setMessage] = useState(false)
  const [dates, setDates] = useState([])
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState(null)
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    shiftStarts: '',
    shiftEnds: '',
    shiftDate: '',
  })

  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  const onChange = (dates) => {
    const [start, end] = dates
    setStartDate(start)
    setEndDate(end)
  }
  const onChangeOverMidnightShift = () => {
    setOverMidnightShift(!overMidnightShift)
  }

  const onChangeforms = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }
  const getSelectedDriver = (e) => {
    let option = e.target.selectedIndex
    var optionElement = e.target.childNodes[option]
    var driverID = optionElement.getAttribute('driver_id')
    let selectedDrivers = [...selectedDriversList]
    let selectedDriver = { driverId: Number(driverID) }
    let check = selectedDrivers.some(
      (driver) => driver.driverId === selectedDriver.driverId
    )
    if (check === true) {
      alert('Kuski on jo valittu')
    } else {
      var selected = { driverId: Number(driverID), name: e.target.value }
      selectedDrivers.push(selected)
      setSelectedDriversList(selectedDrivers)
    }
    document.getElementById('driver_list').selectedIndex = 0
  }

  const getSelectedVehicle = (e, driverId) => {
    let option = e.target.selectedIndex
    var optionElement = e.target.childNodes[option]
    var vehicleID = optionElement.getAttribute('vehicle_id')

    let check = selectedDriversList.some(
      (driver) => driver.vehicleId === Number(vehicleID)
    )
    var driver = selectedDriversList.findIndex((x) => x.driverId === driverId)
    let checkDriver = selectedDriversList[driver].hasOwnProperty('vehicleId')

    if (checkDriver === true) {
      selectedDriversList[driver].vehicleId = Number(vehicleID)
    }
    if (check === true) {
      setMessage('vehicle_error')
      selectedDriversList[driver].errorMessage = true
    } else {
      setMessage(false)
      selectedDriversList[driver].errorMessage = false
      selectedDriversList[driver].vehicleId = Number(vehicleID)
      setSelectedDriversList([...selectedDriversList])
    }
  }
  const getDatesBetweenDates = (startDate, endDate) => {
    let dates = []
    setDates([])
    if (endDate === null && startDate === null) {
      setMessage('date_error')
    } else if (endDate === null) {
      setMessage('date_error')
    } else {
      setMessage('dates_added')
      //to avoid modifying the original date
      const theDate = new Date(startDate)
      while (theDate < endDate) {
        dates = [
          ...dates,
          { shiftDate: moment(new Date(theDate)).format('YYYY-MM-DD') },
        ]
        theDate.setDate(theDate.getDate() + 1)
      }
      dates = [
        ...dates,
        { shiftDate: moment(new Date(endDate)).format('YYYY-MM-DD') },
      ]
      setDates(dates)
      window.setTimeout(function () {
        // Move to a new location
        setMessage(false)
      }, 1600)
    }
  }

  const DeleteSelectedDriver = (e, index) => {
    let selectedDrivers = [...selectedDriversList]
    selectedDrivers.splice(index, 1)
    setSelectedDriversList(selectedDrivers)
  }

  // Submit
  const doSubmit = async (e) => {
    e.preventDefault()
    let driverError = ''
    for (let u = 0; u < selectedDriversList.length; u++) {
      if (selectedDriversList[u].errorMessage === true) {
        driverError = {
          error: true,
          driverId: selectedDriversList[u].driverId,
        }
      }
    }

    if (formData.shiftEnds === '' || formData.shiftStarts === '') {
      alert('Lisää vuoron alku-/loppumisaika')
    } else {
      if (dates.length === 0) {
        alert('Lisää päivämäärä!')
      } else if (selectedDriversList.length === 0) {
        alert('Lisää kuljettaja')
      } else if (driverError.error === true) {
        alert('Tarkista tiedot! KuljettajaID:' + driverError.driverId)
      } else {
        if (overMidnightShift === true) {
          for (let k = 0; k < selectedDriversList.length; k++) {
            for (let i = 0; i < dates.length; i++) {
              var startDate = new Date(dates[i].shiftDate)
              var endDate = new Date(dates[i].shiftDate)
              endDate.setDate(startDate.getDate() + 1)
              var timeEnd = formData.shiftEnds
              var timeStart = formData.shiftStarts

              // // tell moment how to parse the input string
              var endHours = timeEnd.split(':')[0]
              var endMinutes = timeEnd.split(':')[1]
              endHours = endHours % 24 || 24
              endHours = endHours < 10 ? '0' + endHours : endHours

              var startHours = timeStart.split(':')[0]
              var startMinutes = timeStart.split(':')[1]
              startHours = startHours % 24 || 24
              startHours = startHours < 10 ? '0' + startHours : startHours

              var endMomentDate = moment(endDate, 'ddd MMM D YYYY HH:mm ZZ')
              var startMomentDate = moment(startDate, 'ddd MMM D YYYY HH:mm ZZ')

              endMomentDate.set({ h: endHours, m: endMinutes })
              startMomentDate.set({ h: startHours, m: startMinutes })
              // conversion

              var dateTimeStart = startMomentDate.format('YYYY-MM-DDTHH:mm')
              var dateTimeEnd = endMomentDate.format('YYYY-MM-DDTHH:mm')

              let shiftData = {
                driverId: selectedDriversList[k].driverId,
                vehicleId: selectedDriversList[k].vehicleId,
                shiftStarts: new Date(Date.parse(dateTimeStart)).toString(),
                shiftEnds: new Date(Date.parse(dateTimeEnd)).toString(),
              }
              let info = ''
              try {
                await axios
                  .post(`${SERVER_URI}/add_reserved_work_shift`, shiftData, {
                    headers: { Authorization: `Token ${userToken}` },
                  })
                  .then((response) => {
                    info = response.data.reservedShiftId
                  })
              } catch (e) {
                console.log('Error in adding shift', e)
              }
              let shiftDataForReducer = {
                reservedShiftId: info,
                driverId: selectedDriversList[k].driverId,
                vehicleId: selectedDriversList[k].vehicleId,
                shiftStarts: new Date(Date.parse(dateTimeStart)).toString(),
                shiftEnds: new Date(Date.parse(dateTimeEnd)).toString(),
              }
              props.dispatch({
                type: 'ADD_WORKSHIFT',
                data: { newShift: shiftDataForReducer },
              })
              setLoading(true)
            }
          }
          window.setTimeout(function () {
            // Move to a new location
            setLoading(false)
            setShow(!show)
          }, 1400)
        } else {
          for (let k = 0; k < selectedDriversList.length; k++) {
            for (let i = 0; i < dates.length; i++) {
              var date = dates[i].shiftDate
              var timeEnds = formData.shiftEnds
              var timeStarts = formData.shiftStarts
              // tell moment how to parse the input string
              var momentObjEnd = moment(date + timeEnds, 'YYYY-MM-DDLT')
              var momentObjStart = moment(date + timeStarts, 'YYYY-MM-DDLT')

              // conversion
              var dateTimeEnds = momentObjEnd.format('YYYY-MM-DDTHH:mm')
              var dateTimeStarts = momentObjStart.format('YYYY-MM-DDTHH:mm')

              let shiftData = {
                driverId: selectedDriversList[k].driverId,
                vehicleId: selectedDriversList[k].vehicleId,
                shiftStarts: new Date(Date.parse(dateTimeStarts)).toString(),
                shiftEnds: new Date(Date.parse(dateTimeEnds)).toString(),
              }
              let info = ''
              try {
                await axios
                  .post(`${SERVER_URI}/add_reserved_work_shift`, shiftData, {
                    headers: { Authorization: `Token ${userToken}` },
                  })
                  .then((response) => {
                    info = response.data.reservedShiftId
                  })
              } catch (e) {
                console.log('Error in adding shift', e)
              }
              let shiftDataForReducer = {
                reservedShiftId: info,
                driverId: selectedDriversList[k].driverId,
                vehicleId: selectedDriversList[k].vehicleId,
                shiftStarts: new Date(Date.parse(dateTimeStart)).toString(),
                shiftEnds: new Date(Date.parse(dateTimeEnd)).toString(),
              }
              props.dispatch({
                type: 'ADD_WORKSHIFT',
                data: { newShift: shiftDataForReducer },
              })
              setLoading(true)
            }
          }
          window.setTimeout(function () {
            // Move to a new location
            setLoading(false)
            setShow(!show)
          }, 1400)
        }
      }
    }
  }

  return (
    <div>
      <div className='popup-box'>
        <div className='box'>
          <span className='close-icon' onClick={props.handleClose}>
            x
          </span>
          {!show && (
            <div>
              <div className={loading === true ? 'loading' : 'notloading'}>
                Lisätään työvuoroja
              </div>
              <h2 className='popUp_title'>Lisää Työvuoroja</h2>
              <DatePicker
                onChange={onChange}
                startDate={startDate}
                endDate={endDate}
                locale={fi}
                selectsRange
                inline
              />
              <DatePicker
                selected={startDate}
                dateFormat='dd.MM.yyyy'
                disabled
                placeholderText='Aloituspäivä'
              />
              -
              <DatePicker
                selected={endDate}
                dateFormat='dd.MM.yyyy'
                placeholderText='Lopetuspäivä'
                disabled
              />
              <br />
              <button
                id='lightBlue_button'
                onClick={() => getDatesBetweenDates(startDate, endDate)}
              >
                Tallenna päivämäärä(t)
              </button>
              <br />
              {message === 'date_error' ? (
                <div>
                  <label htmlFor='message' className='errorMessage'>
                    Tarkista päivämäärät!
                  </label>
                </div>
              ) : (
                <div>
                  {message === 'dates_added' ? (
                    <div>
                      <label htmlFor='message' className='successMessage'>
                        Päivä(t) tallennettu
                      </label>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              )}
              <form className='addShift_form'>
                <label className='label_add' htmlFor='OverNightShift'>
                  Meneekö vuoro yli keskiyön?
                </label>
                <input
                  type='checkbox'
                  id='OverNightShift'
                  name='OverNightShift'
                  onChange={onChangeOverMidnightShift}
                ></input>
                <br />
                <label className='label_add' htmlFor='StartShift'>
                  Valitse vuoron aloitusaika:
                </label>
                <input
                  type='time'
                  id='shiftStarts'
                  name='shiftStarts'
                  min='00:01'
                  max='23:59'
                  onChange={onChangeforms}
                  required
                ></input>
                <br />

                <label className='label_add' htmlFor='EndShift'>
                  Valitse vuoron loppumisaika:
                </label>
                <input
                  type='time'
                  id='shiftEnds'
                  name='shiftEnds'
                  onChange={onChangeforms}
                  required
                ></input>
                <br />

                <label className='label_add' htmlFor='driver'>
                  Valitse kuljettaja(t):
                </label>
                <select
                  name=''
                  onChange={(e) => getSelectedDriver(e)}
                  className='form-control'
                  id='driver_list'
                >
                  <option value='' hidden>
                    {' '}
                    Valitse kuljettaja
                  </option>
                  {props.driverList.map((driver, index) => (
                    <option key={index} driver_id={driver.driverId}>
                      {driver.name}, Id:{driver.driverId}
                    </option>
                  ))}
                </select>
                <div className='selection_box'>
                  {selectedDriversList.map((driver, index) => (
                    <div key={index}>
                      <li className='driverList'>
                        {driver.name}
                        <select
                          name={driver.name}
                          onChange={(e) =>
                            getSelectedVehicle(e, driver.driverId)
                          }
                          value={driver.vehicleId}
                          className='form-control'
                          id='vehicle_list'
                          required
                        >
                          <option value='' hidden>
                            {' '}
                            Valitse auto
                          </option>
                          {props.vehicleList.map((vehicle, index) => (
                            <option
                              value={vehicle.vehicleId}
                              key={index}
                              vehicle_id={vehicle.vehicleId}
                            >
                              {vehicle.registerPlate}, Id:{vehicle.vehicleId}
                            </option>
                          ))}
                        </select>
                        <span
                          onClick={(e) => DeleteSelectedDriver(e, index)}
                          className='material-icons'
                        >
                          delete
                        </span>
                        {driver.errorMessage === true ? (
                          <div>
                            <label htmlFor='message' className='errorMessage'>
                              Auto on varattu, valitse toinen auto!
                            </label>
                          </div>
                        ) : (
                          ''
                        )}
                      </li>
                    </div>
                  ))}
                </div>
                <input
                  type='submit'
                  id='gradient_Button'
                  onClick={(e) => doSubmit(e)}
                  value='Lisää vuoro'
                />
              </form>
            </div>
          )}
          {show && <CreatedMessage />}
        </div>
      </div>
    </div>
  )
}

export default AddShiftPopup
